export default __webpack_public_path__ + "static/media/control-skin-turkey.a651c52b.png";